/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-pictograms
 *
 */

export type MonochromaticPictogram =
  | 'Accessibility'
  | 'Agent'
  | 'Bank'
  | 'BarChart'
  | 'Bell'
  | 'Bills'
  | 'Binoculars'
  | 'Book'
  | 'Bullet'
  | 'Calendar'
  | 'Cash'
  | 'Chart'
  | 'Chat'
  | 'Chatbot'
  | 'Check'
  | 'Clipboard'
  | 'Crypto'
  | 'CryptoC'
  | 'Deposit'
  | 'Desktop'
  | 'Documents'
  | 'DollarSign'
  | 'Envelope'
  | 'Etf'
  | 'EyeOpen'
  | 'Face'
  | 'Flag'
  | 'Flower'
  | 'Free'
  | 'Gift'
  | 'Help'
  | 'Investing'
  | 'Lightbulb'
  | 'Lightning'
  | 'List'
  | 'LiveChat'
  | 'Lock'
  | 'Margin'
  | 'Megaphone'
  | 'Money'
  | 'PaymentCard'
  | 'Payroll'
  | 'PercentSign'
  | 'Person'
  | 'Phone'
  | 'PieChart'
  | 'PiggyBank'
  | 'PoundSign'
  | 'Recurring'
  | 'Retirement'
  | 'Robinhood'
  | 'Smiley'
  | 'Sparkle'
  | 'Start'
  | 'Stopwatch'
  | 'Submarine'
  | 'Transfer'
  | 'Umbrella'
  | 'Unlock'
  | 'Warning'
  | 'Withdraw'

export type ServerMonochromaticPictogram =
  | 'accessibility'
  | 'agent'
  | 'bank'
  | 'bar_chart'
  | 'bell'
  | 'bills'
  | 'binoculars'
  | 'book'
  | 'bullet'
  | 'calendar'
  | 'cash'
  | 'chart'
  | 'chat'
  | 'chatbot'
  | 'check'
  | 'clipboard'
  | 'crypto'
  | 'crypto_c'
  | 'deposit'
  | 'desktop'
  | 'documents'
  | 'dollar_sign'
  | 'envelope'
  | 'etf'
  | 'eye_open'
  | 'face'
  | 'flag'
  | 'flower'
  | 'free'
  | 'gift'
  | 'help'
  | 'investing'
  | 'lightbulb'
  | 'lightning'
  | 'list'
  | 'live_chat'
  | 'lock'
  | 'margin'
  | 'megaphone'
  | 'money'
  | 'payment_card'
  | 'payroll'
  | 'percent_sign'
  | 'person'
  | 'phone'
  | 'pie_chart'
  | 'piggy_bank'
  | 'pound_sign'
  | 'recurring'
  | 'retirement'
  | 'robinhood'
  | 'smiley'
  | 'sparkle'
  | 'start'
  | 'stopwatch'
  | 'submarine'
  | 'transfer'
  | 'umbrella'
  | 'unlock'
  | 'warning'
  | 'withdraw'

export const MONOCHROMATIC_PICTOGRAMS_LIST: Array<MonochromaticPictogram> = [
  'Accessibility',
  'Agent',
  'Bank',
  'BarChart',
  'Bell',
  'Bills',
  'Binoculars',
  'Book',
  'Bullet',
  'Calendar',
  'Cash',
  'Chart',
  'Chat',
  'Chatbot',
  'Check',
  'Clipboard',
  'Crypto',
  'CryptoC',
  'Deposit',
  'Desktop',
  'Documents',
  'DollarSign',
  'Envelope',
  'Etf',
  'EyeOpen',
  'Face',
  'Flag',
  'Flower',
  'Free',
  'Gift',
  'Help',
  'Investing',
  'Lightbulb',
  'Lightning',
  'List',
  'LiveChat',
  'Lock',
  'Margin',
  'Megaphone',
  'Money',
  'PaymentCard',
  'Payroll',
  'PercentSign',
  'Person',
  'Phone',
  'PieChart',
  'PiggyBank',
  'PoundSign',
  'Recurring',
  'Retirement',
  'Robinhood',
  'Smiley',
  'Sparkle',
  'Start',
  'Stopwatch',
  'Submarine',
  'Transfer',
  'Umbrella',
  'Unlock',
  'Warning',
  'Withdraw',
]

const MONOCHROMATIC_PICTOGRAMS_SERVER_NAME_MAPPING: {
  [k in ServerMonochromaticPictogram]: MonochromaticPictogram
} = {
  accessibility: 'Accessibility',
  agent: 'Agent',
  bank: 'Bank',
  bar_chart: 'BarChart',
  bell: 'Bell',
  bills: 'Bills',
  binoculars: 'Binoculars',
  book: 'Book',
  bullet: 'Bullet',
  calendar: 'Calendar',
  cash: 'Cash',
  chart: 'Chart',
  chat: 'Chat',
  chatbot: 'Chatbot',
  check: 'Check',
  clipboard: 'Clipboard',
  crypto: 'Crypto',
  crypto_c: 'CryptoC',
  deposit: 'Deposit',
  desktop: 'Desktop',
  documents: 'Documents',
  dollar_sign: 'DollarSign',
  envelope: 'Envelope',
  etf: 'Etf',
  eye_open: 'EyeOpen',
  face: 'Face',
  flag: 'Flag',
  flower: 'Flower',
  free: 'Free',
  gift: 'Gift',
  help: 'Help',
  investing: 'Investing',
  lightbulb: 'Lightbulb',
  lightning: 'Lightning',
  list: 'List',
  live_chat: 'LiveChat',
  lock: 'Lock',
  margin: 'Margin',
  megaphone: 'Megaphone',
  money: 'Money',
  payment_card: 'PaymentCard',
  payroll: 'Payroll',
  percent_sign: 'PercentSign',
  person: 'Person',
  phone: 'Phone',
  pie_chart: 'PieChart',
  piggy_bank: 'PiggyBank',
  pound_sign: 'PoundSign',
  recurring: 'Recurring',
  retirement: 'Retirement',
  robinhood: 'Robinhood',
  smiley: 'Smiley',
  sparkle: 'Sparkle',
  start: 'Start',
  stopwatch: 'Stopwatch',
  submarine: 'Submarine',
  transfer: 'Transfer',
  umbrella: 'Umbrella',
  unlock: 'Unlock',
  warning: 'Warning',
  withdraw: 'Withdraw',
}

export type MulticolorPictogram =
  | 'CashAtm'
  | 'CashCalendar'
  | 'CashContactlessPayment'
  | 'CashDocuments'
  | 'CashFlower'
  | 'CashFree'
  | 'CashMoney'
  | 'CashPaymentCard'
  | 'CashSecurity'
  | 'CashStart'
  | 'CashThumbsUp'
  | 'CashUmbrella'
  | 'CashWarning'
  | 'CryptoOrderTypesBuyInShares'
  | 'CryptoOrderTypesBuyLimit'
  | 'CryptoOrderTypesBuyLimitStop'
  | 'CryptoOrderTypesBuyMarket'
  | 'CryptoOrderTypesBuyStop'
  | 'CryptoOrderTypesBuyTrailingStop'
  | 'CryptoOrderTypesBuyWithCrypto'
  | 'CryptoOrderTypesBuyWithDollars'
  | 'CryptoOrderTypesRecurringInvestment'
  | 'CryptoOrderTypesSellLimit'
  | 'CryptoOrderTypesSellLimitStop'
  | 'CryptoOrderTypesSellMarket'
  | 'CryptoOrderTypesSellStop'
  | 'CryptoOrderTypesSellTrailingStop'
  | 'GoldBarChart'
  | 'GoldCalendar'
  | 'GoldDocuments'
  | 'GoldGift'
  | 'GoldMargin'
  | 'GoldMoney'
  | 'GoldPiggyBank'
  | 'GoldStopwatch'
  | 'OrderTypesBuyInShares'
  | 'OrderTypesBuyLimit'
  | 'OrderTypesBuyLimitStop'
  | 'OrderTypesBuyMarket'
  | 'OrderTypesBuyStop'
  | 'OrderTypesBuyTrailingStop'
  | 'OrderTypesBuyWithDollars'
  | 'OrderTypesRecurringInvestment'
  | 'OrderTypesSellLimit'
  | 'OrderTypesSellLimitStop'
  | 'OrderTypesSellMarket'
  | 'OrderTypesSellStop'
  | 'OrderTypesSellTrailingStop'
  | 'PrimeChart'
  | 'PrimeDollarSign'
  | 'PrimeFlag'
  | 'PrimeFlower'
  | 'PrimeForwardSplit'
  | 'PrimeGift'
  | 'PrimeMoney'
  | 'PrimePieChart'
  | 'PrimePoundSign'
  | 'PrimeRecurring'
  | 'PrimeRetirement'
  | 'PrimeReverseSplit'
  | 'PrimeRobot'

export type ServerMulticolorPictogram =
  | 'cash_atm'
  | 'cash_calendar'
  | 'cash_contactless_payment'
  | 'cash_documents'
  | 'cash_flower'
  | 'cash_free'
  | 'cash_money'
  | 'cash_payment_card'
  | 'cash_security'
  | 'cash_start'
  | 'cash_thumbs_up'
  | 'cash_umbrella'
  | 'cash_warning'
  | 'crypto_order_types_buy_in_shares'
  | 'crypto_order_types_buy_limit'
  | 'crypto_order_types_buy_limit_stop'
  | 'crypto_order_types_buy_market'
  | 'crypto_order_types_buy_stop'
  | 'crypto_order_types_buy_trailing_stop'
  | 'crypto_order_types_buy_with_crypto'
  | 'crypto_order_types_buy_with_dollars'
  | 'crypto_order_types_recurring_investment'
  | 'crypto_order_types_sell_limit'
  | 'crypto_order_types_sell_limit_stop'
  | 'crypto_order_types_sell_market'
  | 'crypto_order_types_sell_stop'
  | 'crypto_order_types_sell_trailing_stop'
  | 'gold_bar_chart'
  | 'gold_calendar'
  | 'gold_documents'
  | 'gold_gift'
  | 'gold_margin'
  | 'gold_money'
  | 'gold_piggy_bank'
  | 'gold_stopwatch'
  | 'order_types_buy_in_shares'
  | 'order_types_buy_limit'
  | 'order_types_buy_limit_stop'
  | 'order_types_buy_market'
  | 'order_types_buy_stop'
  | 'order_types_buy_trailing_stop'
  | 'order_types_buy_with_dollars'
  | 'order_types_recurring_investment'
  | 'order_types_sell_limit'
  | 'order_types_sell_limit_stop'
  | 'order_types_sell_market'
  | 'order_types_sell_stop'
  | 'order_types_sell_trailing_stop'
  | 'prime_chart'
  | 'prime_dollar_sign'
  | 'prime_flag'
  | 'prime_flower'
  | 'prime_forward_split'
  | 'prime_gift'
  | 'prime_money'
  | 'prime_pie_chart'
  | 'prime_pound_sign'
  | 'prime_recurring'
  | 'prime_retirement'
  | 'prime_reverse_split'
  | 'prime_robot'

export const MULTICOLOR_PICTOGRAMS_LIST: Array<MulticolorPictogram> = [
  'CashAtm',
  'CashCalendar',
  'CashContactlessPayment',
  'CashDocuments',
  'CashFlower',
  'CashFree',
  'CashMoney',
  'CashPaymentCard',
  'CashSecurity',
  'CashStart',
  'CashThumbsUp',
  'CashUmbrella',
  'CashWarning',
  'CryptoOrderTypesBuyInShares',
  'CryptoOrderTypesBuyLimit',
  'CryptoOrderTypesBuyLimitStop',
  'CryptoOrderTypesBuyMarket',
  'CryptoOrderTypesBuyStop',
  'CryptoOrderTypesBuyTrailingStop',
  'CryptoOrderTypesBuyWithCrypto',
  'CryptoOrderTypesBuyWithDollars',
  'CryptoOrderTypesRecurringInvestment',
  'CryptoOrderTypesSellLimit',
  'CryptoOrderTypesSellLimitStop',
  'CryptoOrderTypesSellMarket',
  'CryptoOrderTypesSellStop',
  'CryptoOrderTypesSellTrailingStop',
  'GoldBarChart',
  'GoldCalendar',
  'GoldDocuments',
  'GoldGift',
  'GoldMargin',
  'GoldMoney',
  'GoldPiggyBank',
  'GoldStopwatch',
  'OrderTypesBuyInShares',
  'OrderTypesBuyLimit',
  'OrderTypesBuyLimitStop',
  'OrderTypesBuyMarket',
  'OrderTypesBuyStop',
  'OrderTypesBuyTrailingStop',
  'OrderTypesBuyWithDollars',
  'OrderTypesRecurringInvestment',
  'OrderTypesSellLimit',
  'OrderTypesSellLimitStop',
  'OrderTypesSellMarket',
  'OrderTypesSellStop',
  'OrderTypesSellTrailingStop',
  'PrimeChart',
  'PrimeDollarSign',
  'PrimeFlag',
  'PrimeFlower',
  'PrimeForwardSplit',
  'PrimeGift',
  'PrimeMoney',
  'PrimePieChart',
  'PrimePoundSign',
  'PrimeRecurring',
  'PrimeRetirement',
  'PrimeReverseSplit',
  'PrimeRobot',
]

const MULTICOLOR_PICTOGRAMS_SERVER_NAME_MAPPING: {
  [k in ServerMulticolorPictogram]: MulticolorPictogram
} = {
  cash_atm: 'CashAtm',
  cash_calendar: 'CashCalendar',
  cash_contactless_payment: 'CashContactlessPayment',
  cash_documents: 'CashDocuments',
  cash_flower: 'CashFlower',
  cash_free: 'CashFree',
  cash_money: 'CashMoney',
  cash_payment_card: 'CashPaymentCard',
  cash_security: 'CashSecurity',
  cash_start: 'CashStart',
  cash_thumbs_up: 'CashThumbsUp',
  cash_umbrella: 'CashUmbrella',
  cash_warning: 'CashWarning',
  crypto_order_types_buy_in_shares: 'CryptoOrderTypesBuyInShares',
  crypto_order_types_buy_limit: 'CryptoOrderTypesBuyLimit',
  crypto_order_types_buy_limit_stop: 'CryptoOrderTypesBuyLimitStop',
  crypto_order_types_buy_market: 'CryptoOrderTypesBuyMarket',
  crypto_order_types_buy_stop: 'CryptoOrderTypesBuyStop',
  crypto_order_types_buy_trailing_stop: 'CryptoOrderTypesBuyTrailingStop',
  crypto_order_types_buy_with_crypto: 'CryptoOrderTypesBuyWithCrypto',
  crypto_order_types_buy_with_dollars: 'CryptoOrderTypesBuyWithDollars',
  crypto_order_types_recurring_investment:
    'CryptoOrderTypesRecurringInvestment',
  crypto_order_types_sell_limit: 'CryptoOrderTypesSellLimit',
  crypto_order_types_sell_limit_stop: 'CryptoOrderTypesSellLimitStop',
  crypto_order_types_sell_market: 'CryptoOrderTypesSellMarket',
  crypto_order_types_sell_stop: 'CryptoOrderTypesSellStop',
  crypto_order_types_sell_trailing_stop: 'CryptoOrderTypesSellTrailingStop',
  gold_bar_chart: 'GoldBarChart',
  gold_calendar: 'GoldCalendar',
  gold_documents: 'GoldDocuments',
  gold_gift: 'GoldGift',
  gold_margin: 'GoldMargin',
  gold_money: 'GoldMoney',
  gold_piggy_bank: 'GoldPiggyBank',
  gold_stopwatch: 'GoldStopwatch',
  order_types_buy_in_shares: 'OrderTypesBuyInShares',
  order_types_buy_limit: 'OrderTypesBuyLimit',
  order_types_buy_limit_stop: 'OrderTypesBuyLimitStop',
  order_types_buy_market: 'OrderTypesBuyMarket',
  order_types_buy_stop: 'OrderTypesBuyStop',
  order_types_buy_trailing_stop: 'OrderTypesBuyTrailingStop',
  order_types_buy_with_dollars: 'OrderTypesBuyWithDollars',
  order_types_recurring_investment: 'OrderTypesRecurringInvestment',
  order_types_sell_limit: 'OrderTypesSellLimit',
  order_types_sell_limit_stop: 'OrderTypesSellLimitStop',
  order_types_sell_market: 'OrderTypesSellMarket',
  order_types_sell_stop: 'OrderTypesSellStop',
  order_types_sell_trailing_stop: 'OrderTypesSellTrailingStop',
  prime_chart: 'PrimeChart',
  prime_dollar_sign: 'PrimeDollarSign',
  prime_flag: 'PrimeFlag',
  prime_flower: 'PrimeFlower',
  prime_forward_split: 'PrimeForwardSplit',
  prime_gift: 'PrimeGift',
  prime_money: 'PrimeMoney',
  prime_pie_chart: 'PrimePieChart',
  prime_pound_sign: 'PrimePoundSign',
  prime_recurring: 'PrimeRecurring',
  prime_retirement: 'PrimeRetirement',
  prime_reverse_split: 'PrimeReverseSplit',
  prime_robot: 'PrimeRobot',
}

export type Pictogram = MonochromaticPictogram | MulticolorPictogram

export type ServerPictogram =
  | ServerMonochromaticPictogram
  | ServerMulticolorPictogram

export const PICTOGRAMS_LIST: Array<Pictogram> = [
  ...MONOCHROMATIC_PICTOGRAMS_LIST,
  ...MULTICOLOR_PICTOGRAMS_LIST,
]

export const PICTOGRAMS_SERVER_NAME_MAPPING = {
  ...MONOCHROMATIC_PICTOGRAMS_SERVER_NAME_MAPPING,
  ...MULTICOLOR_PICTOGRAMS_SERVER_NAME_MAPPING,
}
